<template>
    <div>
        <div class="search-wrapper">
            <b-container class="pt-3 pb-2">
                <Search :search="search" @update-search="updateSearch" /> 
            </b-container>
        </div>
        <div v-if="!noResult" class="search-results" ref="searchResults">
            <b-container fluid>
                <b-row>
                    <b-col md="7">
                        <CovidAlert/>
                        <SortFilter :search="search" v-model="search.sort" @update-search="updateSearch" />
                        <HotelResults :exchangerates="exchangerates" :errors="errors" :results="filteredItems" :search="search"/>
                        <b-pagination class="search-pagination mt-4 mb-4"  v-on:input="handlePageination" align="center" v-model="search.page" :per-page="perPage" :total-rows="results.length"/>
                    </b-col>
                    <b-col md="5">
                        <HotelMapResults :exchangerates="exchangerates" :results="filteredItems" :search="search"/>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div v-else class="search-results">
            <b-container>
                <b-alert class="mt-4 mb-4" show variant="info">
                    <strong>We couldn't find</strong> the hotels matching your search criteria. Check your spelling or try searching something else.
                </b-alert>
            </b-container>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import CovidAlert from "@/components/ui/CovidAlert.vue"
    import Search from "@/components/ui/Search.vue"
    import HotelResults from "@/components/ui/HotelResults.vue"
    import SortFilter from "@/components/ui/SortFilter.vue"
    import HotelMapResults from "@/components/ui/HotelMapResults.vue"

    export default {
        components: {
            CovidAlert,
            Search,
            HotelResults,
            HotelMapResults,
            SortFilter,
        },
        computed: {
            filteredItems: function () {
                if (this.results.length > this.perPage) {
                    var start = (this.search.page - 1) * this.perPage;
                    var end = this.search.page * this.perPage;

                    return this.results.slice(start, end)
                }

                return this.results
            }
        },
       data () {
            return {
                offset: '',
                search: {
                    place: {
                        name: '',
                        lat: '',
                        lng: '',
                    },
                    date: {
                        checkin: '',
                        checkout: '',
                    },
                    occupation: {
                        adults: 0,
                        rooms: 0,
                        children: 0,
                        ages: [],
                    },
                    sort: '',
                    currency: '',
                    page: 1,
                },
                errors: [],
                results: [],
                exchangerates: {},
                limit: 100,
                perPage: 25,
                noResult: false,
            }
        },
        mounted () {
            this.search.place.name = (this.$route.query.search ? this.$route.query.search : null);
            this.search.place.lat = (this.$route.query.lat ? this.$route.query.lat : null);
            this.search.place.lng = (this.$route.query.lng ? this.$route.query.lng : null);
            this.search.date.checkin = (this.$route.query.checkin ? this.$route.query.checkin : null);
            this.search.date.checkout = (this.$route.query.checkout ? this.$route.query.checkout : null);
            this.search.occupation.adults = (this.$route.query.adults ? parseInt(this.$route.query.adults) : 0);
            this.search.occupation.children = (this.$route.query.children ? parseInt(this.$route.query.children) : 0);
            this.search.occupation.rooms = (this.$route.query.rooms ? parseInt(this.$route.query.rooms) : 0);
            this.search.occupation.ages = (this.$route.query.ages ? JSON.parse(this.$route.query.ages) : []);
            this.search.currency = (this.$route.query.currency ? this.$route.query.currency : 'EUR');
            this.search.sort = (this.$route.query.sort ? this.$route.query.sort : null);
            this.search.page = (this.$route.query.page ? this.$route.query.page : 1);
            this.loadResults();
        },
        methods: {
            updateSearch(search) {
                this.search = search;
                this.offset = '';
                this.results = [];
                this.noResult = false;
                this.loadResults();
            },
            loadResults() {

                let self = this;

                axios
                    .get('https://api.stay.com.de/?action=hotel-search' + 
                        '&currency=' + self.search.currency +
                        '&lat=' + self.search.place.lat + 
                        '&lng=' + self.search.place.lng +
                        '&checkin=' + self.search.date.checkin +
                        '&checkout=' + self.search.date.checkout +
                        '&adults=' + self.search.occupation.adults +
                        '&children=' + self.search.occupation.children +
                        '&ages=' + JSON.stringify(self.search.occupation.ages) +
                        '&rooms=' + self.search.occupation.rooms +
                        '&sort=' + self.search.sort +
                        '&offset=' + self.offset +
                        '&mode=' + process.env.VUE_APP_MODE
                        
                    )
                    .then(function(response) {

                        self.exchangerates = {};

                        if (response.data.dictionaries) {
                            if (response.data.dictionaries.currencyConversionLookupRates) {
                                self.exchangerates = response.data.dictionaries.currencyConversionLookupRates;
                            }
                        }

                        if (response.data.data) {

                            self.results = self.results.concat(response.data.data);

                            if (response.data.meta && response.data.meta.links.next) {
                                var next = new URLSearchParams(response.data.meta.links.next);
                                self.offset = next.get('page[offset]');
                            } else {
                                self.offset = '';
                            }

                            if (self.offset != '' && self.results.length < self.limit) {
                                self.loadResults();
                            }
                        } else {
                            self.noResult = true;
                        }

                        if (response.data.errors) {
                            self.errors = response.data.errors;
                        }
                    })
                ;
            },
            handlePageination(page) {
                this.search.page = page;
                this.$refs.searchResults.scrollIntoView({behavior: "smooth", block: "start"});

                this.$router.push({
                    path: `/${this.$route.params.locale}/hotels/`, query: {
                        search: this.search.place.name,
                        lat: this.search.place.lat,
                        lng: this.search.place.lng,
                        checkin: this.search.date.checkin,
                        checkout: this.search.date.checkout,
                        adults: this.search.occupation.adults,
                        children: this.search.occupation.children,
                        rooms: this.search.occupation.rooms,
                        ages: JSON.stringify(this.search.occupation.ages),
                        sort: this.search.sort,
                        page: this.search.page,
                    }
                });
            }
        }
    }
</script>

<style>
    @media screen and (min-width:991px) {
        .search-wrapper .form-group{
            margin:0;
        }
    }

    .search-pagination .page-link{
        padding: 0.65rem 1.5rem;
    }
</style>
<style scoped>
    .search-wrapper{
        background-color:#F3F3F3;
    }
</style>